import API from './API.js'
import axios from 'axios'
import { serialize } from 'object-to-formdata';


export default class Comment extends API {
  constructor() {
    super('comment')
  }

  async getContentComments(programId, contentId) {
    try {
      const response = await axios.get(`/getContentComments?contentId=${contentId}&programId=${programId}`)
      return this.listToTree(response.data.data)
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }
  }
  async storeContentComments(data) {

    const options = {
      indices: true,
      nullsAsUndefineds: false,
      booleansAsIntegers: false,
      allowEmptyArrays: true,
    };

    const formData = serialize(data, options);

    var headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
        charset: 'utf-8',
        boundary: Math.random().toString().substr(2),
      },

    }

    const response = await axios.post(`/storeContentComments`, formData, headers)
    return response.data

  }
  listToTree(list) {
    var map = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parent_id !== null) {
        list[map[node.parent_id]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
}